import { render, staticRenderFns } from "./SharePoster.vue?vue&type=template&id=5bd2e214&scoped=true"
import script from "./SharePoster.vue?vue&type=script&lang=js"
export * from "./SharePoster.vue?vue&type=script&lang=js"
import style0 from "./SharePoster.vue?vue&type=style&index=0&id=5bd2e214&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd2e214",
  null
  
)

export default component.exports